import React from 'react';

const SvgLock = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 13 16" {...props}>
    <path
      fill="currentColor"
      d="M6.5 0C3.8 0 1.625 1.946 1.625 4.364v1.978C.616 7.367 0 8.71 0 10.182 0 13.395 2.91 16 6.5 16s6.5-2.605 6.5-5.818c0-1.473-.616-2.815-1.625-3.84V4.364C11.375 1.946 9.201 0 6.5 0zm0 1.455c1.85 0 3.25 1.253 3.25 2.909v.785a7.046 7.046 0 0 0-3.25-.785 7.05 7.05 0 0 0-3.25.785v-.785c0-1.656 1.4-2.91 3.25-2.91zM6.5 8c.894 0 1.625.655 1.625 1.455 0 .534-.33.998-.813 1.251v2.385H5.688v-2.385c-.482-.253-.812-.717-.812-1.251C4.875 8.655 5.606 8 6.5 8z"
    />
  </svg>
);

export default SvgLock;
